import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { message } from 'antd';

const AuthContext = createContext();

// 创建一个 axios 实例用于 API 请求
export const apiClient = axios.create();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

// 添加请求拦截器来自动添加 accessToken
apiClient.interceptors.request.use(
  (config) => {
    // 确保 headers 对象存在
    config.headers = config.headers || {};
    
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['accessToken'] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 添加响应拦截器处理认证错误
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // 检查响应是否包含特定的错误代码
    if (error.response && error.response.data && error.response.data.code === 401) {
      // 特定的401错误消息，表示登录已过期
      message.error('认证未通过，请重新登录');
      localStorage.removeItem('user');
      localStorage.removeItem('accessToken');
      // 使用setTimeout延迟跳转，确保消息显示
      setTimeout(() => {
        window.location.href = '/login';
      }, 1000);
    } else if (error.response && error.response.status === 401) {
      // 原有的401状态码检查
      message.error('认证未通过，请重新登录');
      localStorage.removeItem('user');
      localStorage.removeItem('accessToken');
      // 使用setTimeout延迟跳转，确保消息显示
      setTimeout(() => {
        window.location.href = '/login';
      }, 1000);
    }
    return Promise.reject(error);
  }
);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); // 添加加载状态
  const [user, setUser] = useState(null);

  useEffect(() => {
    // 检查本地存储中是否有用户信息
    const savedUser = localStorage.getItem('user');
    const accessToken = localStorage.getItem('accessToken');
    
    if (savedUser && accessToken) {
      setUser(JSON.parse(savedUser));
      setIsAuthenticated(true);
    }
    setLoading(false); // 加载完成
  }, []);

  const login = (userData, accessToken) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem('user', JSON.stringify(userData));
    if (accessToken) {
      localStorage.setItem('accessToken', accessToken);
    }
  };

  const logout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem('user');
    localStorage.removeItem('accessToken');
  };

  const value = {
    isAuthenticated,
    user,
    login,
    logout,
    loading,
    apiClient
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};